const REQ_CODE = {
    'REQ_OK' : '200'
}
import axios from 'axios';
import fileDownload from 'js-file-download';
import qs from 'qs';

axios.defaults.retry = 1;
axios.defaults.retryDelay = 1000;

let http = axios.create({
    withCredentials: false, //`withCredentials` 表示跨域请求时是否需要使用凭证
    crossDomain:true,
    timeout: 60000
});

http.interceptors.request.use(function (config) {
    if( sessionStorage.getItem( 'USER_TOKEN_TAG' ) != undefined && sessionStorage.getItem( 'USER_TOKEN_VAL' ) !=undefined ){
        let _tokenTag           = sessionStorage.getItem( 'USER_TOKEN_TAG' );
        let _tokenVal           = sessionStorage.getItem( 'USER_TOKEN_VAL' );
        config.headers.common[_tokenTag] = _tokenVal;
    }else if( localStorage.getItem( 'USER_TOKEN_TAG' ) != undefined && localStorage.getItem( 'USER_TOKEN_VAL' ) !=undefined ){
        let _tokenTag           = localStorage.getItem( 'USER_TOKEN_TAG' );
        let _tokenVal           = localStorage.getItem( 'USER_TOKEN_VAL' );
        config.headers.common[_tokenTag] = _tokenVal;
    }
    if (localStorage.getItem('token') != undefined) {
        let token = localStorage.getItem("token");
        config.headers.common['token'] = token;
    }
    config.headers.common = Object.assign( config.headers.common, config.commonHeaders );
    if (config.method === 'get') {
        config.paramsSerializer = function(params) {
            return qs.stringify(params, { arrayFormat: 'repeat' })
        }
    }
    return config;
}, function (error) {
    // Do something with request error
    console.info("error: ");
    console.info(error);
    return Promise.reject(error);
});


// http 响应拦截器
http.interceptors.response.use((response) => {
  return response
}, error => {
  //超时处理
  var config = error.config;
  if (!config || !config.retry) return Promise.reject(error);
  // 设置用于跟踪重试次数的变量
  config.__retryCount = config.__retryCount || 0;

  // 检查我们是否已将重试总数最大化
  if (config.__retryCount >= config.retry) {
    // 错误拒绝
    return Promise.reject(error);
  }

  // 增加重试次数
  config.__retryCount += 1;

  // 创造新的承诺来处理指数退避
  var backoff = new Promise(function (resolve) {
    setTimeout(function () {
      resolve();
    }, config.retryDelay || 1);
  });

  // 返回承诺，其中将撤回axios以重试请求
  return backoff.then(function () {
    return http(config);
  });
  // return Promise.reject(error)
})




/**
 * 全局http请求对象封装
 * @param method String 请求类型： GET|POST|PUT|DELETE
 * @param url String 请求URL路径
 * @param params Object 请求参数
 * @param response function 处理完成的回调函数
 * @param headers Object 发送请求时使用的header信息
 * @param hostName String 主机名称
 * @param responseType String 返回结果类型 arraybuffer|document|json(default)|text|stream
 */
// console.log( window.$app.conf.host );
window.apiAxios = function (method, url, params, response, headers, commonHeaders, hostName, responseType ) {
    http({
        method          : method === 'DELETE_BODY' ? 'DELETE' : method,
        url             : hostName === null || hostName === undefined ? url : hostName + url,
        data            : method === 'POST' || method === 'PUT' || method === 'PATCH' || method === 'DELETE_BODY' ? params : null,
        params          : method === 'GET' || method === 'DELETE' ? params : null,
        headers         : headers !== undefined && headers != null ? headers : null,
        commonHeaders   : commonHeaders !== undefined && commonHeaders != null ? commonHeaders : {},
        responseType    : responseType === undefined ? '' : responseType,
        // crossdomain: true,
    })
    .then(function(res) {
        if (res === null || res === undefined) {
            return;
        }
        /**
         * 通过用判断
         */
        if( false == REQ_CODE.REQ_OK ){
            return ;
        }
        response(res?.data, res);
    })
    .catch(function(err) {
        if (err.response) {
            /*token超时*/
            if( err.response?.data?.code == 500 && ( err.response?.data?.msg == "操作失败，token无效" || err.response?.data?.msg == "token无效"  )  ){
					// 设置登录状态
					sessionStorage.setItem( "USER_ISLOGIN", "false" );
					$store.dispatch( "setLogin", false );
					// 删除登录satoken
					localStorage.setItem( "USER_TOKEN_VAL", '' );
					// 记录回跳路径
					sessionStorage.setItem( "loginRedir", Vue.$route.path );
					// 跳转登录
					Vue.$router.push('/user/login')

			}else
                response(err.response);
        } else if (err.request) {
            console.log( "接口调用失败", err.request );
			response(false)
            /*if (err.request.readyState == 4 && err.request.status == 0 && err.code == "ECONNABORTED") {
                window.apiAxios(method, url, params, response, headers, hostName, responseType)
            }*/
        }
    });
}

/**
 * @fileOverview 监管前端脚手架通用js请求封装
 * @author 郭猛
 * @module $jgApiAxios
 */
export default {
    /**
     * 生成AJAX请求需要的默认头信息
     * @return {{"jg-userId": (string | null), "jg-token": (string | null), "jg-userName": (string), token: string}}
     */
    getDefHeader: function(){
        if( sessionStorage.getItem( 'USER_TOKEN_TAG' ) && sessionStorage.getItem( 'USER_TOKEN_VAL' ) ){
            let _tokenTag           = sessionStorage.getItem( 'USER_TOKEN_TAG' );
            let _tokenVal           = sessionStorage.getItem( 'USER_TOKEN_VAL' );
            let _headers            = [];
            _headers[_tokenTag]     = _tokenVal;
            return _headers;
        }

        if( localStorage.getItem( 'USER_TOKEN_TAG' ) && localStorage.getItem( 'USER_TOKEN_VAL' ) ){
            let _tokenTag           = localStorage.getItem( 'USER_TOKEN_TAG' );
            let _tokenVal           = localStorage.getItem( 'USER_TOKEN_VAL' );
            let _headers            = [];
            _headers[_tokenTag]     = _tokenVal;
            return _headers;
        }
    },

    /**
     * 生成URL
     */
    makeUrl: function( url, cache = false ){
        return cache ? url : `${url}${/\?/g.test(url) ? '&' : '?'}t=${new Date().getTime()}`;
    },
    /**
     * 发送GET请求<br/>该请求会自动添加一个用于防止缓存的时间戳参数 t
     *
     * @param url 请求地址
     * @param params 请求参数
     * @param response 请求结束回调
     * @param hostName 主机名称
     */
    get: function(url, params, response, hostName, cache = false, responseType= undefined) {
        let headers = this.getDefHeader();
        url = this.makeUrl( url, cache);
        return window.apiAxios('GET', url, params, response, headers, {}, hostName,responseType);
    },

    /**
     * 发送POST请求
     * @param url 请求地址
     * @param params 请求参数
     * @param response 请求结束回调
     * @param actInfo 业务信息
     */
    post: function(url, params, response, actInfo ) {
        let headers = this.getDefHeader();
        let _actInfo    = actInfo ? { "act-inf" : actInfo } : false;
        return window.apiAxios('POST', url, params, response, headers, _actInfo );
    },

    /**
     * 使用REQUEST-BODY方式发送POST请求
     * @param url 请求地址
     * @param params 请求参数
     * @param response 请求结束回调
     * @param hostName 主机名称
     */
    postRequestBody: function(url, params, response, hostName) {
        let headers = this.getDefHeader();
        headers["Content-Type"] = 'application/json;charset=UTF-8';
        return window.apiAxios('POST', url, params, response, {}, {}, hostName);
    },
    /**
     * 发送PUT请求
     * @param url 请求地址
     * @param params 请求参数
     * @param response 请求结束回调
     * @param hostName 主机名称
     */
    put: function(url, params, response, hostName) {
        let headers = this.getDefHeader();
        return window.apiAxios('PUT', url, params, response, headers, {}, hostName);
    },

    /**
     * 发送PATCH请求
     * @param url
     * @param params
     * @param response
     * @param hostName
     */
    patch: function(url, params, response, hostName) {
        let headers = this.getDefHeader();
        return window.apiAxios('PATCH', url, params, response, headers, {}, hostName);
    },

    /**
     * 发送DELETE请求
     * @param url 请求地址
     * @param params 请求参数
     * @param response 请求结束回调
     * @param hostName 主机名称
     */
    delete: function(url, params, response, hostName) {
        let headers = this.getDefHeader();
        return window.apiAxios('DELETE', url, params, response, headers, {}, hostName);
    },

    /**
     * GET方式发送文件下载请求
     * @param url 请求地址
     * @param params 请求参数
     * @param response 请求结束回调
     * @param hostName 主机名称
     */
    download: function(url, params, fileName, response, hostName) {
        let headers = this.getDefHeader();
        return window.apiAxios('GET', url, params, ( r, res ) => {
            if( res.status == 200 ){
                fileDownload( r, fileName );
                response( r );
            }else{
                window.Vue.$message.error( "文件下载失败" );
            }
        }, headers, {}, hostName, "blob");
    },

    /**
     * POST方式发送文件下载请求
     * @param url 请求地址
     * @param params 请求参数
     * @param response 请求结束回调
     * @param hostName 主机名称
     */
    downloadPost: function(url, params, responseType, response, hostName) {
        let headers = this.getDefHeader();
        return window.apiAxios('POST', url, params, r => {
            if( response ){
                response( r );
            }
            fileDownload( r.data, fileName );
        }, headers, {}, hostName, "blob");
    },

    /**
     * 使用序列化字符串的方式发送基于键值对的POST请求
     * @param url 请求地址
     * @param params 请求参数
     * @param response 请求结束回调
     * @param hostName 主机名称
     */
    postForm: function(url, params, response, hostName) {
        let headers = this.getDefHeader();
        headers["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";
        let qsparam = qs.stringify(params)
        return window.apiAxios('POST', url, qsparam, response, headers, {}, hostName);
    },
    /**
     * 使用from-data方式发送GET请求
     * @param url String 请求地址
     * @param params Object 请求参数
     * @param response Object 请求结束回调
     * @param hostName String 主机名称
     */
    getForm: function(url, params, response, hostName) {
        let headers = this.getDefHeader();
        headers["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";
        return window.apiAxios('GET', url, params, response, headers, {}, hostName);
    },

    /**
     * 使用序列化字符串的方式发送基于FROM-DATA的POST请求
     * @param url
     * @param params
     * @param response
     * @param hostName
     */
    postRequestForm: function(url, params, response, hostName) {
        let FormData    = require('form-data');
        let data        = new FormData();
        Object.keys( params ).forEach( _k => {
          data.append( _k, params[_k] );
        } )
        let headers = this.getDefHeader();
        return window.apiAxios('POST', url, data, response, headers, {}, hostName);
    },

    /**
     * 使用序列化字符串的方式发送基于FROM-PUT
     * @param url
     * @param params
     * @param response
     * @param hostName
     */
    putRequestForm: function(url, params, response, hostName) {
        let FormData    = require('form-data');
        let data        = new FormData();
        Object.keys( params ).forEach( _k => {
          data.append( _k, params[_k] );
        } )
        let headers = this.getDefHeader();
        return window.apiAxios('PUT', url, data, response, headers, {}, hostName);
    },

    deleteBody : function( url, data, response, hostName ){
        let headers = this.getDefHeader();
        return window.apiAxios('DELETE_BODY', url, data, response, headers, {}, hostName);
    },

    /**
     * POST调用转发接口
     * @param url
     * @param params
     * @returns {Promise<unknown>|AxiosPromise<any>}
     */
    agentPost : function ( url, params, response ){
        let headers = this.getDefHeader();
        let _params = {
            url     : url,
            method  : "POST",
            body    : {
                "type"  : "application/json",
                "params": params
            },
            header  : {},
            files   : [],
        }
        return window.apiAxios('POST', `${config.serverUrl}/cmss/v1/comp-service/api/send`, _params, response, headers );
    },

    /**
     * GET调用转发接口
     * @param url
     * @param params
     * @returns {Promise<unknown>|AxiosPromise<any>}
     */
    agentGet : function ( url, params, response ){
        let headers = this.getDefHeader();
        let _param  = qs.stringify(params);
        let _url    = url.indexOf( "?" ) >= 0 ? `${url}&${_param}` : `${url}?${_param}`;

        let _params = {
            url     : _url,
            method  : "Get",
            body    : {},
            header  : {},
            files   : [],
        }

        return window.apiAxios('POST', `${config.serverUrl}/cmss/v1/comp-service/api/send`, _params, response, headers );
    },

    apmSyncPost  : function( apiId, params, commonHeaders, response ){
        let _headers = this.getDefHeader();
       
        return window.apiAxios('POST', `${config.serverUrl}/cmss/v1/comp-service/apm/sync/cmd/ability/${apiId}`, params, response, _headers, commonHeaders );
    },

    apmASyncPost  : function( apiId, params, commonHeaders, response ){
        let _headers = this.getDefHeader();
       
        return window.apiAxios('POST', `${config.serverUrl}/cmss/v1/comp-service/apm/async/cmd/ability/${apiId}`, params, response, _headers, commonHeaders );
    },

    apmSyncFilePost  : function( apmFile, params, commonHeaders, response ){
        let _headers = this.getDefHeader();
        let _param   = {
            rule    : apmFile,
            data    : params
        }
        return window.apiAxios('POST', `${config.serverUrl}/cmss/v1/comp-service/apm/sync/file`, _param, response, _headers, commonHeaders );
    },

    apmASyncFilePost  : function( apmFile, apiId, params, commonHeaders, response ){
        let _headers = this.getDefHeader();
        let _param   = {
            apiId   : apiId,
            rule    : apmFile,
            data    : params
        }
        return window.apiAxios('POST', `${config.serverUrl}/cmss/v1/comp-service/apm/async/file`, _param, response, {}, commonHeaders );
    },

    integrityCheckASyncPost  : function( apiId, params, commonHeaders, response ){
        let _headers = this.getDefHeader();
        return window.apiAxios('POST', `${config.serverUrl}/cmss/v1/comp-service/jdTest/fileCheck/ability/${apiId}`, params, response, {}, commonHeaders );
    },

    integrityCheckJDASyncPost  : function( apiId, params, commonHeaders, response ){
        let _headers = this.getDefHeader();
        return window.apiAxios('POST', `${config.serverUrl}/cmss/v1/comp-service/jd/fileCheck/ability/${apiId}`, params, response, {}, commonHeaders );
    },

    apmAsyncResult  : function( taskId, commonHeaders, response ){
        let _headers = this.getDefHeader();
       
        return window.apiAxios('GET', `${config.serverUrl}/cmss/v1/comp-service/apm/async/status/${taskId}`, {}, response, _headers, commonHeaders );
    },

    apmAbilityPost  : function( apiId, params, commonHeaders, response ){
        let _headers = this.getDefHeader();
        return window.apiAxios('POST', `${config.serverUrl}/apm/v1/ability/${apiId}`, params, response, _headers, commonHeaders );
    }
};
